/**
 * Moldura das telas de entrada (login e cadastro): formulário à esquerda,
 * ilustração à direita. As duas telas repetiam este layout e o cabeçalho da
 * marca, e foi assim que o logo acabou com tamanhos diferentes em cada uma —
 * com um único lugar, ele não tem como divergir de novo.
 */
function AuthLayout({ title, tagline, children }) {
  return (
    <div className="auth-shell d-flex">
      <div className="auth-pane d-flex flex-column justify-content-center align-items-center flex-grow-1 p-4 p-md-5">
        <div className="auth-card">
          <div className="text-center mb-4">
            <img src="/images/icon-horizontal.png" alt="MyPedidos" className="auth-logo" />
            {title && <h1 className="auth-title">{title}</h1>}
            {tagline && <p className="auth-tagline mb-0">{tagline}</p>}
          </div>

          {children}
        </div>
      </div>

      {/* A ilustração é decorativa: some no celular, onde ela tomaria a tela
          inteira antes de o usuário ver o formulário. */}
      <div className="auth-art d-none d-md-block">
        <img src="/images/wallpaper.png" alt="" />
        {/* Sem esta borda o recorte da imagem termina numa linha reta no pé da
            tela e a arte parece cortada em vez de emoldurada. */}
        <div className="auth-art-fade" />
      </div>
    </div>
  );
}

export default AuthLayout;
